export const CHAT_TABLE = 'chat_messages_20240520';
export const ADMIN_TABLE = 'chat_admins_1786723472726';
export const MODERATION_TABLE = 'chat_moderation_1786723472726';